<script setup>
import { useStore } from 'vuex'
import { routes } from '@/router'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import YearSelect from '@/components/year/YearSelect.vue'

const store = useStore()
const route = useRoute()
const router = useRouter()

const navigationRoutes = computed(() => {
  const projectRoutes = routes[2]
  return projectRoutes.children.filter((item) => !!item.meta.sideBar)
})
const currentProject = computed(() => store.state.project.currentProject)
const drawer = computed(() => store.state.project.drawer)
const width = computed(() => store.getters['project/sideBarWidth'])

const toggleDrawer = () => store.dispatch('project/toggleDrawer')

const navigateTo = (navigationItem) => {
  if (navigationItem.name !== route.name) {
    const key = navigationItem.meta.key ?? null
    const timeout = route.name === 'dikeIndex-trajectory' ? 200 : 0
    setTimeout(
      () =>
        router.push({
          name: navigationItem.name,
          params: {
            id: currentProject.value.id,
            revisionId: currentProject.value.currentprojectuser[key]
          }
        }),
      timeout
    )
  }
}

const navigationTo = (navigationItem) => {
  if (drawer.value) {
    navigationItem.name ? navigateTo(navigationItem) : null
  } else {
    toggleDrawer()
  }
}
</script>

<template>
  <v-navigation-drawer style="z-index: 1000" v-if="currentProject" :width="width" absolute>
    <v-list color="primary" class="py-0">
      <v-list-item v-if="drawer" color="none" active-class="none">
        <v-tooltip location="bottom" open-delay="500" max-width="300px">
          <template #activator="{ props }">
            <v-list-item-title class="text-h6" v-bind="props">
              <div class="text-h6 elip" style="display: inline-block">
                {{ currentProject?.name }}
              </div>
            </v-list-item-title>
          </template>
          <span> {{ currentProject?.name }}</span>
        </v-tooltip>
        <v-list-item-subtitle>
          <v-chip class="pl-1" label size="x-small">
            <v-icon class="mr-1" size="x-small">mdi-map-marker</v-icon>
            {{ currentProject?.location }}
          </v-chip>
          <span class="ml-3">
            {{ currentProject?.client }}
          </span>
        </v-list-item-subtitle>
      </v-list-item>
      <div v-for="(navigationItem, i) in navigationRoutes" :key="i">
        <v-divider v-if="!navigationItem.meta.subItem && drawer"></v-divider>
        <v-list-item
          v-if="!navigationItem.meta.select || (navigationItem.meta.select && drawer)"
          @click="navigationTo(navigationItem)"
          :active="route.name === navigationItem.name"
        >
          <template #prepend>
            <v-icon
              v-if="!navigationItem.meta.select"
              :icon="navigationItem.meta.icon"
              class="pl-1"
            />
          </template>
          <template v-if="drawer">
            <v-list-item-title v-if="navigationItem.meta.select">
              <YearSelect
                v-if="navigationItem.meta.title === 'Design years'"
                :navigation-item="navigationItem"
              />
            </v-list-item-title>
            <div v-else>
              {{ navigationItem.meta.title }}
            </div>
          </template>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>
